import { CloseIcon } from 'assets/icons/CloseIcon'
import { Modal } from 'components/Modal/Modal'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import useModalClose from 'hooks/useModalClose'
import { CursorPointer, Flex, ItemsGrid, ModalScrollContainer, ThinSeparator } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { IGetAllInventoryTransfersSingleResponse } from 'types/api/inventoryReceiptsApi.interface'
import { formatDateForDisplay } from 'utils/helpers'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const ViewInventoryTransferModal = ({ closeModal, value }: { closeModal: any, value?: IGetAllInventoryTransfersSingleResponse }) => {
    useFocusFirstInput()
    useModalClose(closeModal)

    return <Modal black>
        <ModalScrollContainer>
            <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                <TitleText weight='bold' >Transfer Preview</TitleText>
                <CursorPointer onClick={closeModal} >
                    <CloseIcon />
                </CursorPointer>
            </Flex>
            <ItemsGrid columns={2} >
                <TextDisplayCard title={formatDateForDisplay(value.date)} labelText='Date' />
                <TextDisplayCard title={value.performedByUser ? value?.performedByUser?.firstName + ' ' + value?.performedByUser?.lastName : '/'} labelText='Performed By' />
                <TextDisplayCard title={value.assignedForUser ? value?.assignedForUser?.firstName + ' ' + value?.assignedForUser?.lastName : '/'} labelText='Assigned Employee' />
                <TextDisplayCard title={value.fromLocation ? value.fromLocation.name : '/'} labelText='From location' />
                <TextDisplayCard title={value.toLocation ? value.toLocation.name : '/'} labelText='To location' />
            </ItemsGrid>

            <TextDisplayCard style={{ marginTop: 16 }} title={value.notes || '/'} labelText='Notes' width='100%' />

            <ThinSeparator />
            <Flex column gap='1rem'  >
                <BodyText weight='bold' >Items:</BodyText>
                {value.lines.map(l => <Flex key={l.id} column width='100%'>
                    <Flex width='100%' gap='1rem'  >
                        <TextDisplayCard width='100%' title={l.inventoryItem ? l.inventoryItem.name : '/'} labelText='Item' />
                        <TextDisplayCard width='100%' title={l.quantity} labelText='Quantity' />
                    </Flex>
                    <TextDisplayCard style={{ marginTop: 16 }} title={l.lineNotes || '/'} labelText='Notes' width='100%' />
                    <ThinSeparator margin='5px' />
                </Flex>)}
            </Flex>


        </ModalScrollContainer>
    </Modal>
}

